import React from "react";
import { motion } from "framer-motion";
import { UserPlus, FileSearch, Eye, TrendingUp } from "lucide-react";

const steps = [
  {
    icon: UserPlus,
    label: "Step 1",
    title: "Create Your Profile",
    body: "Share your business details, products or services, certifications, and capabilities.",
  },
  {
    icon: FileSearch,
    label: "Step 2",
    title: "Review & Curation",
    body: "Our team reviews your profile to maintain the quality and credibility of the Exchange.",
  },
  {
    icon: Eye,
    label: "Step 3",
    title: "Get Listed",
    body: "Your business becomes discoverable to buyers, organizations, and partners.",
  },
  {
    icon: TrendingUp,
    label: "Step 4",
    title: "Grow Through Opportunities",
    body: "Receive visibility through sourcing requests, partnerships, and initiatives.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 md:py-32 bg-brand-cream relative" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-brand-wine">
            How It Works
          </span>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.1] text-brand-ink">
            From profile to <span className="italic text-brand-wine">opportunity</span>.
          </h2>
          <p className="mt-5 text-lg text-brand-muted">
            A simple, curated path — designed to help you grow.
          </p>
        </div>

        <div className="mt-20 relative">
          <div className="hidden lg:block absolute top-10 left-[8%] right-[8%] h-[2px] bg-gradient-to-r from-transparent via-brand-wine/40 to-transparent" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8 relative">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                  className="relative text-center flex flex-col items-center"
                  data-testid={`step-${i + 1}`}
                >
                  <div className="w-20 h-20 rounded-full bg-brand-wine text-white flex items-center justify-center relative z-10 shadow-[0_18px_40px_-15px_rgba(139,30,63,0.5)]">
                    <Icon size={26} strokeWidth={1.6} />
                  </div>
                  <span className="mt-6 text-xs uppercase tracking-[0.25em] font-semibold text-brand-wine">
                    {s.label}
                  </span>
                  <h3 className="mt-2 font-serif text-2xl font-semibold text-brand-ink">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[15px] text-brand-muted leading-relaxed max-w-xs">
                    {s.body}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
